module.exports = __webpack_public_path__ + "static/browser-hello-world-2eea7615e1ff546e37c6e31a6844e9b2.png";